import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import BaseRow from "@cirrus/legacy/app-components/table-v2/table-rows/base-row/index.jsx"

import styles from "../../common-styles/styles.less"

class SelectableRow extends C {
  static displayName = "SelectableTableRow"

  static propTypes = {
    isSelected: PropTypes.bool.isRequired,
  }

  render() {
    let className = classNames(
      styles.selectable,
      { [styles.selected]: this.props.isSelected },
      this.props.className,
    )

    return (
      <BaseRow {...this.props} className={className}>
        {this.props.children}
      </BaseRow>
    )
  }
}
export default SelectableRow
